import { createSlice } from '@reduxjs/toolkit';
import { AppThunk } from '../../store';
import { getLastModemSwapDisplay, setLastModemSwapDisplay } from '../../helper/storage';

interface CustomerCommunicationState {
  lastModemSwapDialogVisible: boolean;
};

const initialState: CustomerCommunicationState = {
  lastModemSwapDialogVisible: false,
};

export const showCustomerCommunicationAfterMeasurement = (): AppThunk<Promise<void>> => async (dispatch, getState) => {
  const waitPromise = new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, 1500);
  });

  await waitPromise;
  const lastModemSwapDisplay = getLastModemSwapDisplay();
  const show = lastModemSwapDisplay == null || Date.now() - lastModemSwapDisplay.getTime() > 2 * 24 * 3600 * 1000;
  if (show) {
    dispatch(customerCommunicationSlice.actions.showLastModemSwapDialog());
    setLastModemSwapDisplay(new Date());
  }
}

export const customerCommunicationSlice = createSlice({
  name: 'customerCommunication',
  initialState,
  reducers: {
    showLastModemSwapDialog: (state) => {
      state.lastModemSwapDialogVisible = true;
    },
    hideLastModemSwapDialog: (state) => {
      state.lastModemSwapDialogVisible = true;
    },
  },
});

export const { hideLastModemSwapDialog } = customerCommunicationSlice.actions;
export default customerCommunicationSlice;